<template>
  <div class="juou-card">
    <HpsfirProTable
      ref="tableRef"
      export-file-name="快递公司管理"
      title="快递公司管理"
      :paginations="{ pageSize: 10 }"
      :columns="columns"
      :get-data="getData"
      :on-add="addFun"
      :on-delete="deleteFun"
      :on-edit="updateFun"
      :loading="loading"
      :is-dangder-delete="true"
      :format-dangder-delete-info="formatDeleteInfo"
      row-key="id"
      :operates="operates"
      :operation-width="150"
      :add-init-values="addInitValue"
      :codition-init-values="conditionsInitValue"
    />
  </div>
</template>
<script lang="ts" setup>
import {
  useBaseAsync,
  type HpsfirProTableColumn,
  type HpsfirProTableData,
  type HpsfirProTableFilter,
  type HpsfirProTableGetDataFunction,
} from 'hpsfir-managebase-ui';

import { useApi } from '@/hooks/useApi';
import { ElMessage } from 'element-plus';
import { ref } from 'vue';
import { normalizeBizTableColumns } from '@/utils/tableColumns';

const columns = ref<HpsfirProTableColumn[]>(normalizeBizTableColumns([]));
const tableRef = ref<any>();

const addInitValue = {
};

const conditionsInitValue = {
};

const init = useBaseAsync(() => {
  columns.value = normalizeBizTableColumns([
    {
      name: 'companyName',
      label: '公司名称',
      type: 'string',
      isCondition: true,
      rule: [{ required: true }],
      width: 150,
    },
    {
      name: 'companyCode',
      label: '公司编码',
      type: 'string',
      isCondition: true,
      rule: [{ required: true }],
      width: 150,
    },
    {
      name: 'companyImage',
      label: '公司图片',
      type: 'image',
      rule: [{ required: true }],
      width: 120,
      action: useApi().uploadImageUrl,
      multiple: false,
      onSuccess(data) {
        tableRef.value?.tableForm?.setOneFormState('companyImage', data.data[0]);
      },
    },
    {
      name: 'createTime',
      label: '创建时间',
      type: 'string',
      hideEdit: true,
      hideCreate: true,
      width: 160,
    },
  ]);
});

const operates: any[] = [];

const loading = ref(false);

const getData = useBaseAsync<HpsfirProTableGetDataFunction>(async(filter: HpsfirProTableFilter) => {
  try {
    loading.value = true;
    const res = await useApi().expressCompanyApi.pageExpressCompanyexpressCompany({
      conditions: Object.entries(filter.conditions).reduce((conditions, [key, val]) => {
        if (val === null || val === undefined || val === '') {
          return conditions;
        }
        conditions[key] = val;
        return conditions;
      }, {} as any),
      pageQuery: {
        page: filter.paginations.page - 1,
        pageSize: filter.paginations.pageSize,
      },
    });

    const tableData: HpsfirProTableData = {
      total: res.data.data?.total || 0,
      data: res.data.data?.data || [],
    };
    return tableData;
  } finally {
    loading.value = false;
  }
});

const formatDeleteInfo = (row: any) => `您确定要删除"${row.companyName}"吗？此操作不可恢复，请谨慎操作。`;

const addFun = useBaseAsync(async(data: any) => {
  await useApi().expressCompanyApi.addExpressCompanyexpressCompany({
    expressCompanyAdminVo: {
      ...data,
    },
  });
  ElMessage.success('添加成功');
});

const updateFun = useBaseAsync(async(data: any) => {
  await useApi().expressCompanyApi.updateExpressCompanyexpressCompany({
    expressCompanyAdminVo: {
      ...data,
    },
  });
  ElMessage.success('修改成功');
});

const deleteFun = useBaseAsync(async(data: any) => {
  await useApi().expressCompanyApi.delExpressCompanyexpressCompany(data.id);
  ElMessage.success('删除成功');
});

init();
</script>
<style lang="scss" scoped>
</style>
